export const manifest = {
  screens: {
    scr_rfg9mg: { name: "Landing page", route: "/", state: {"view":"join"}, position: {"x":160,"y":220} },
    scr_r2zn95: { name: "Q1 · Your years", route: "/", state: {"view":"join","open":true,"stepIndex":0}, position: {"x":1560,"y":220} },
    scr_2i5o4d: { name: "Q2 · Your connection", route: "/", state: {"view":"join","open":true,"stepIndex":1}, position: {"x":2960,"y":220} },
    scr_pq6z9n: { name: "Q3 · Your name", route: "/", state: {"view":"join","open":true,"stepIndex":2}, position: {"x":4360,"y":220} },
    scr_29gw6h: { name: "Q4 · Reaching you", route: "/", state: {"view":"join","open":true,"stepIndex":3}, position: {"x":5760,"y":220} },
    scr_3nyus4: { name: "Q5 · Your visibility", route: "/", state: {"view":"join","open":true,"stepIndex":4}, position: {"x":7160,"y":220} },
    scr_id3l0h: { name: "Q6 · What you were part of", route: "/", state: {"view":"join","open":true,"stepIndex":5}, position: {"x":8560,"y":220} },
    scr_e7vjia: { name: "Q7 · What you remember", route: "/", state: {"view":"join","open":true,"stepIndex":6}, position: {"x":9960,"y":220} },
    scr_ysxk78: { name: "Welcome", route: "/", state: {"view":"join","open":true,"flowDone":true}, position: {"x":11360,"y":220} },
    scr_ech3zy: { name: "Check your email", route: "/", state: {"view":"join","open":false,"flowDone":true}, position: {"x":12760,"y":220} },
    scr_99iy3u: { name: "Invite landing", route: "/", state: {"view":"invite"}, position: {"x":160,"y":2200} },
    scr_1u6gzr: { name: "Expired link", route: "/", state: {"view":"expired"}, position: {"x":1560,"y":2200} },
    scr_ua2bs6: { name: "Member home", route: "/", state: {"view":"dashboard","section":"home"}, position: {"x":160,"y":4180} },
    scr_li7f2j: { name: "Member home — 12 members", route: "/", state: {"view":"dashboard","section":"home","sparse":true}, position: {"x":1560,"y":4180} },
    scr_c65ou1: { name: "People", route: "/", state: {"view":"dashboard","section":"people"}, position: {"x":160,"y":6160} },
    scr_oq5ajj: { name: "Events", route: "/", state: {"view":"dashboard","section":"events"}, position: {"x":4360,"y":6160} },
    scr_ek1x29: { name: "Archive", route: "/", state: {"view":"dashboard","section":"archive"}, position: {"x":1560,"y":6160} },
    scr_zu8wkj: { name: "Voices", route: "/", state: {"view":"dashboard","section":"voices"}, position: {"x":2960,"y":6160} },
    scr_1xba3o: { name: "Your profile", route: "/", state: {"view":"dashboard","section":"profile"}, position: {"x":160,"y":8140} },
    scr_6q5q7h: { name: "Another member's profile", route: "/", state: {"view":"dashboard","section":"profile","profileName":"Theresa Molina"}, position: {"x":1560,"y":8140} },
    scr_laazuz: { name: "Memorial profile", route: "/", state: {"view":"dashboard","section":"profile","profileName":"Sean Duffy"}, position: {"x":2960,"y":8140} },
  },
  sections: {
    sec_05ieas: { name: "Onboarding", x: 0, y: 0, width: 14120, height: 1180 },
    sec_6wuhek: { name: "Invite & Access", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_45qnlh: { name: "Home & Dashboard", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_66et92: { name: "Main Navigation", x: 0, y: 5940, width: 5720, height: 1180 },
    sec_enukpa: { name: "Profiles", x: 0, y: 7920, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_05ieas", children: [
      { kind: "screen", id: "scr_rfg9mg" },
      { kind: "screen", id: "scr_r2zn95" },
      { kind: "screen", id: "scr_2i5o4d" },
      { kind: "screen", id: "scr_pq6z9n" },
      { kind: "screen", id: "scr_29gw6h" },
      { kind: "screen", id: "scr_3nyus4" },
      { kind: "screen", id: "scr_id3l0h" },
      { kind: "screen", id: "scr_e7vjia" },
      { kind: "screen", id: "scr_ysxk78" },
      { kind: "screen", id: "scr_ech3zy" },
    ] },
    { kind: "section", id: "sec_6wuhek", children: [
      { kind: "screen", id: "scr_99iy3u" },
      { kind: "screen", id: "scr_1u6gzr" },
    ] },
    { kind: "section", id: "sec_45qnlh", children: [
      { kind: "screen", id: "scr_ua2bs6" },
      { kind: "screen", id: "scr_li7f2j" },
    ] },
    { kind: "section", id: "sec_66et92", children: [
      { kind: "screen", id: "scr_c65ou1" },
      { kind: "screen", id: "scr_ek1x29" },
      { kind: "screen", id: "scr_zu8wkj" },
      { kind: "screen", id: "scr_oq5ajj" },
    ] },
    { kind: "section", id: "sec_enukpa", children: [
      { kind: "screen", id: "scr_1xba3o" },
      { kind: "screen", id: "scr_6q5q7h" },
      { kind: "screen", id: "scr_laazuz" },
    ] },
  ],
}
